import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

export default function Task(props) {
  const { task, taskName, userId, taskType, onClick } = props;
  const isSmallDevice = window.innerWidth < 760;

  return (
    <Draggable draggableId={`${taskType}_${task.id}_${userId}`} index={userId+task.id} isDragDisabled={isSmallDevice}>
      {(provided, snapshot) => (
        <label
          onClick={onClick}
          ref={provided.innerRef}
          className="text-nowrap"
          style={{ cursor: 'move' }}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          htmlFor={`task-${task.id}`}
        >
          <p className="text--wrap" dangerouslySetInnerHTML={{ __html: taskName.naglowek }}></p>
          <p className="text--wrap font-normal" dangerouslySetInnerHTML={{ __html: taskName.info }}></p>
        </label>
      )}
    </Draggable>
  );
}
